module.exports = __webpack_public_path__ + "img/busImg.1abb4149.png";